import { schema } from "normalizr";

import { Entity } from "@/mk2/schemas";

export interface NoteEntity extends Entity {
    note: string;
}

export const NoteSchema = new schema.Entity("notes.note", {});
